export const PODCASTS_EMPTY_STATE_TITLE =
  "You haven't posted any audiograms from an RSS feed";

export const PODCASTS_EMPTY_STATE_DESCRIPTION =
  'Any videos you create from an RSS feed and share to YouTube or social media platforms will be reported on here. This allows you to see views, likes, and comments all in one place.';
